import { Injectable } from '@angular/core';
import { NbToastrService, NbComponentStatus } from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class MessageHandlerService {

  constructor(private toastrService: NbToastrService) { }

  error(e){
    let text = e.error.message || "Something unexpected happened 🤔"

    switch (text) {
      case "Validation errors":
        text = "Some fields are missing 🤔"
        break;
    
    }

    this.toastrService.danger(text,"ERROR", {icon: "alert-circle-outline"})
    console.error(e)
  }

  success(message?){
    let text = message || ""
    this.toastrService.success(text,"Done!", {icon: "checkmark-circle-outline"})
  }
  
}
